import {
	Button,
	Checkbox,
	FormControlLabel,
	MuiThemeProvider,
	TextField,
	createMuiTheme,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
	deleteDocumentsTag,
	getDocumentsTagById,
	postDocumentsTag,
	updateDocumentsTag,
} from "../../../../api/documentsTag";
import { checkIsEmpty } from "../../../../utils/helpers";
import { alertError, alertSuccess } from "../../../../utils/logger";
import MultilanguageTabBlock from "../../../components/MultilanguageTabBlock";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { changes, setChanges } from "../../../../utils/globals";

// Create theme for delete button (red)
const theme = createMuiTheme({
	palette: {
		secondary: {
			main: "#F64E60",
		},
	},
});

function getEmptyDocumentsTag() {
	return {
		name: null,
		active: true,
	};
}

export default function EditDocumentsTagPage() {
	const [documentsTag, setDocumentsTag] = useState(getEmptyDocumentsTag());
	const [openConfirmDialog, setOpenConfirmDialog] = useState(0);

	const documentsTagId = useParams().id;
	const history = useHistory();
	const user = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	const {
		isLoading: isLoadingData,
		disableLoading: disableLoadingData,
		ContentSkeleton,
	} = useSkeleton();

	// const [changes, setChanges] = useState(-2);
	useEffect(() => setChanges(-2), []);
	useEffect(() => {
		if (!documentsTagId) setChanges(changes+2);
		else setChanges(changes+1);
	}, [documentsTag])

	useEffect(() => {
		if (!documentsTagId) {
			disableLoadingData();
			return;
		}
		getDocumentsTagById(documentsTagId)
			.then((res) => {
				if (res.status === 200) {
					setDocumentsTag(res.data);
					disableLoadingData();
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get documents tag.",
				});
				setChanges(0);
				history.push("/documents-tag");
			});
	}, [documentsTagId, disableLoadingData, history]);

	function saveDocumentsTag() {
		if (!documentsTag.name)
			return alertError({
				error: null,
				customMessage:
					"The name is required in at least one of the languages.",
			});
		if (!documentsTagId) {
			postDocumentsTag(documentsTag)
				.then((res) => {
					if (res.status === 201) {
						alertSuccess({
							title: "Saved!",
							customMessage: "Documents tag successfully created.",
						});
						setChanges(0);
						history.push("/documents-tag");
					}
				})
				.catch((error) => {
					alertError({
						error: error,
						customMessage: "Could not save documents tag.",
					});
				});
		} else {
			updateDocumentsTag(documentsTagId, documentsTag)
				.then((res) => {
					if (res.status === 200) {
						alertSuccess({
							title: "Saved!",
							customMessage: "Changes successfully saved.",
						});
						setChanges(0);
						history.push("/documents-tag");
					}
				})
				.catch((error) => {
					alertError({
						error: error,
						customMessage: "Could not save changes.",
					});
				});
		}
	}

	const handleChange = (element) => (event) => {
		setDocumentsTag({
			...documentsTag,
			[element]: event.target.value,
		});
	};

	const renderMultilanguageTabContent = (lang) => {
		return (
			<>
				<br />
				<TextField
					id={`name`}
					label="Name"
					value={
						(documentsTag.name) || ""
					}
					onChange={handleChange("name")}
					InputLabelProps={{
						shrink: true,
					}}
					margin="normal"
					variant="standard"
					required
				/>
			</>
		);
	};

	if (isLoadingData) return <ContentSkeleton />;
	else
		return (
			<>
				<Card>
				<CardHeader title={documentsTag?._id?'Documents tag: ' + (documentsTag.name? documentsTag.name:''):'New documents tag'}>
					<div className="mt-5">
						<Button
							onClick={() => {
								if (changes > 0) setOpenConfirmDialog(1);
								else history.push("/documents-tag");
							}}
							variant="outlined"
							style={{ marginRight: "20px" }}
						>
							Back
						</Button>
						<Button
							onClick={() => saveDocumentsTag()}
							variant="outlined"
							color="primary"
							style={{ marginRight: "20px" }}
						>
							Save documents tag
						</Button>
						<ConfirmDialog
							title={
								"Are you sure you want to go back? You will lose all your changes"
							}
							open={openConfirmDialog === 1}
							setOpen={setOpenConfirmDialog}
							onConfirm={() => {
								setChanges(0);
								history.push("/documents-tag")
							}}
						/>
						{documentsTagId && user?.role.includes("admin") && (
							<>
								<MuiThemeProvider theme={theme}>
									<Button
										onClick={() => setOpenConfirmDialog(2)}
										variant="outlined"
										color="secondary"
										style={{ marginRight: "20px" }}
									>
										Delete documents tag
									</Button>
									<div
										style={{
											display: "flex",
											flexDirection: "row",
											marginLeft: "auto",
										}}
									></div>
								</MuiThemeProvider>

								<ConfirmDialog
									title={
										"Are you sure you want to delete this documents tag?"
									}
									open={openConfirmDialog === 2}
									setOpen={setOpenConfirmDialog}
									onConfirm={() => {
										deleteDocumentsTag(documentsTagId)
											.then((res) => {
												if (
													res.status === 204 ||
													res.status === 200
												) {
													alertSuccess({
														title: "Deleted!",
														customMessage:
															"Documents tag deleted successfully",
													});
													setChanges(0);
													history.push("/documents-tag");
												}
											})
											.catch((error) => {
												alertError({
													error: error,
													customMessage:
														"Could not delete documents tag.",
												});
											});
									}}
								/>
							</>
						)}
					</div>
				</CardHeader>
					<CardBody>
						<MultilanguageTabBlock
							multilanguageTabContent={
								renderMultilanguageTabContent
							}
						/>
						<FormControlLabel
							control={
								<Checkbox
									checked={documentsTag.active}
									onChange={() =>
										setDocumentsTag({
											...documentsTag,
											active: !documentsTag.active,
										})
									}
									name="checkActive"
								/>
							}
							label="Active"
						/>
					</CardBody>
				</Card>
			</>
		);
}
